module.exports = __webpack_public_path__ + "img/01.8342b4cb.jpg";